import React from 'react';
import { DefaultRoutes, SiteType, getSiteConfig } from '../libs/common/siteConfig';
import { getThemeColors } from '../libs/common/themeConfig';

/**
 * Elegant CS/R6 site switcher
 */
export const SiteSwitch = () => {
  const siteConfig = getSiteConfig();
  const currentSite = siteConfig.type;
  const themeColors = getThemeColors();

  const handleSwitch = (targetSite) => {
    if (targetSite === currentSite) return;

    // Get default route for target site
    const defaultRoute = DefaultRoutes[targetSite] || '/';

    // Redirect to the other site's default route
    // In production, this would redirect to the other domain
    if (targetSite === SiteType.CS) {
      window.location.href = `https://majors.im${defaultRoute}`;
    } else {
      window.location.href = `https://r6.majors.im${defaultRoute}`;
    }
  };

  return (
    <div
      className="flex items-center gap-1 p-1"
      style={{
        backgroundColor: themeColors.surface,
        border: `1px solid ${themeColors.border}`,
        borderRadius: '0.25rem',
      }}
    >
      <button
        onClick={() => handleSwitch(SiteType.CS)}
        className={`px-3 py-2 text-[0.8125rem] font-medium rounded transition-all min-h-[2.5rem] min-w-[2.5rem] touch-manipulation ${
          currentSite !== SiteType.CS ? 'hover:bg-[var(--hover-bg)]' : ''
        }`}
        style={{
          ...(currentSite === SiteType.CS
            ? {
                backgroundColor: '#2563eb',
                color: '#ffffff',
              }
            : {
                color: themeColors.textSecondary,
                backgroundColor: 'transparent',
                '--hover-bg': themeColors.hover,
              }),
        }}
      >
        CS
      </button>
      <button
        onClick={() => handleSwitch(SiteType.R6)}
        className={`px-3 py-2 text-[0.8125rem] font-medium rounded transition-all min-h-[2.5rem] min-w-[2.5rem] touch-manipulation ${
          currentSite !== SiteType.R6 ? 'hover:bg-[var(--hover-bg)]' : ''
        }`}
        style={{
          ...(currentSite === SiteType.R6
            ? {
                backgroundColor: '#ea580c',
                color: '#ffffff',
              }
            : {
                color: themeColors.textSecondary,
                backgroundColor: 'transparent',
                '--hover-bg': themeColors.hover,
              }),
        }}
      >
        R6
      </button>
    </div>
  );
};
